import React from 'react';
import './EVLocateMe.scss';
import { trackEvent } from 'helpers/Analytics';

interface IEVLocateMe {
  disable: boolean;
}

export function EVLocateMe({ disable }: IEVLocateMe): JSX.Element {
  const isHonda = process.env.REACT_APP_THEME === 'honda';
  const buttonClass = isHonda ? '-honda' : '';
  const handleModal = () => {
    var event = new CustomEvent('react-zipgate-open', {
      detail: {
        hideCloseButton: false,
      },
    });
    window.dispatchEvent(event);
    trackEvent({
      label: 'csl:locate me',
      category: {
        includePageName: false,
        text: 'csl:locate me',
      },
      type: 'selector',
      modelSeries: 'zdx',
      modelYear: '2024',
      bodyStyle: 'suvs',
    });
  };
  return (
    <div className="ev-locate-me">
      <button
        className={`ev-locate-me__button${buttonClass} acr-shadow-2`}
        onClick={handleModal}
        disabled={disable}
      />
    </div>
  );
}

export default EVLocateMe;
